﻿import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';   //ngIf etc...
import { FormsModule } from '@angular/forms'; // ngModel etc...
import { RouterModule, Routes } from '@angular/router';
import { HttpModule, RequestOptions } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

//bootstrap
import * as bootstrap from '@ng-bootstrap/ng-bootstrap';

//resize
import { ResizableModule } from 'angular-resizable-element';


//------------------
//application
//------------------
import { Config } from './config/config';
import { AuthService } from './security/auth.service';
import { DialogService } from './service/dialog.service';
import { ErrorLogService } from './service/error-log.service';
import { AuthGuard } from './security/auth-guard.service';
import { SurveyService} from '../shared/service/SurveyService';
import { AuthorizeDirective } from './security/authorize.directive';
import { AppRequestOptions } from './config/AppRequestOptions';
import { HttpAuthInterceptor } from './config/http-auth.interceptor';
import { HttpJsonInterceptor } from './config/http-json.interceptor';
import { DatePickerAdapter } from './config/date-picker.adapter';
import { EuropeanDatePickerFormatter } from './config/date-picker.formatter';
import { HtmlPipe } from './pipe/html.pipe';
import { SafeHtmlPipe } from './pipe/safehtml.pipe'; 
import { AutofocusDirective } from './directive/autofocus.directive';
import { DraggableDirective } from './directive/draggable.directive';

//shared components
import { BreadCrumbComponent } from './component/breadcrumb/breadcrumb.component';
import { EchrHeaderComponent } from './component/echr-header/echr-header.component';
import { EchrFooterComponent } from './component/echr-footer/echr-footer.component';
import { ContentToggleComponent } from './component/content-toggle/content-toggle.component';
import { ConfirmComponent  } from './component/modals/confirm/confirm.component';
import { LanguageLocalisationComponent } from './component/Localisation/language-localisation.component';
//import { CaptchaComponent} from './component/Captcha/Captcha.component';


let bootstrapModules = [
    bootstrap.NgbCollapseModule,
    bootstrap.NgbAccordionModule,
    bootstrap.NgbAlertModule,
    bootstrap.NgbButtonsModule,
    bootstrap.NgbDatepickerModule,
    bootstrap.NgbDropdownModule,
    bootstrap.NgbModalModule,
    bootstrap.NgbPopoverModule,
    bootstrap.NgbTabsetModule,
    bootstrap.NgbTimepickerModule,
    bootstrap.NgbTooltipModule,
    bootstrap.NgbTypeaheadModule
];



@NgModule({

    entryComponents: [
        ConfirmComponent,
    ],
    declarations: [
        AuthorizeDirective,
        AutofocusDirective,
        DraggableDirective,
        HtmlPipe,
        SafeHtmlPipe,

        BreadCrumbComponent,
          EchrHeaderComponent,
        EchrFooterComponent,    
        ContentToggleComponent,
        ConfirmComponent,
        LanguageLocalisationComponent,
        //CaptchaComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        HttpModule,
        HttpClientModule,
        BrowserAnimationsModule,
        RouterModule,

        //3rd parties module
        ResizableModule,
        ...bootstrapModules

    ],
    exports: [

        CommonModule,
        FormsModule,
        BrowserAnimationsModule,

        ////re-export modules and component to make them available in any module using SharedModule
        //...wijmoModules,
        //WjComponentLoader,

        ResizableModule,
        ...bootstrapModules,

        //export shared components/directives
        AuthorizeDirective,
        AutofocusDirective,
        DraggableDirective,
        HtmlPipe,
        SafeHtmlPipe,

        EchrHeaderComponent,
        EchrFooterComponent,
        BreadCrumbComponent,
             ContentToggleComponent,
        ConfirmComponent,
        LanguageLocalisationComponent,
        //CaptchaComponent,
    ],
    providers: [
        AuthService,
        AuthGuard,
        DialogService,
        ErrorLogService,
        SurveyService,
        { provide: RequestOptions, useClass: AppRequestOptions },
        { provide: HTTP_INTERCEPTORS, useClass: HttpAuthInterceptor, multi: true }, //automatically set the credential options
        { provide: HTTP_INTERCEPTORS, useClass: HttpJsonInterceptor, multi: true }, //automatically convert json date to javascript date
        { provide: bootstrap.NgbDateParserFormatter, useClass: EuropeanDatePickerFormatter }, //automatically format date to dd/MM/yyyy
        { provide: bootstrap.NgbDateAdapter, useClass: DatePickerAdapter } //automatically transform datepicker date struct to javascript date

    ],
})
export class SharedModule { }